<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0': $vuetify.breakpoint.xs,'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <div>
                    <v-layout row wrap align-center
                              justify-space-between mb-4 :class="{'mx-3': $vuetify.breakpoint.xs}"
                    >
                        <v-flex sm8 xs12>
                            <h1 class="section-title-main my-3 font-weight-regular">{{ $t("Правила обучения и обратная связь") }}</h1>
                        </v-flex>
                        <v-flex v-if="learning_rules" sm12 v-html="learning_rules" />
                        <v-flex sm8 xs12>
                            <h4 class="section-title">{{ $t("Если у вас остались вопросы") }}:</h4>
                        </v-flex>
                        <v-flex sm4 text-sm-right text-xs-left>
                            <buttonRed @click.native="OPEN_CONTACT_MODAL()">{{ $t("Задать вопрос") }}</buttonRed>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap align-end
                              justify-space-between mb-5 :class="{'mx-3': $vuetify.breakpoint.xs}"
                    >
                        <v-flex sm5 xs12 :class="{'mb-4': $vuetify.breakpoint.xs,'mr-4 mb-0': $vuetify.breakpoint.smAndUp}">
                            <inputIcon v-model="questions_search" class="layout row search--no-border" icon_name="search"
                                       :placeholder="$t('Поиск по разделу')"
                            />
                        </v-flex>
                        <v-flex sm6>
                            <div class="grey-text mb-2">{{ $t("Тема вопроса") }}</div>
                            <v-select
                                v-model="theme"
                                :items="translatedThemes"
                                solo
                                append-icon=""
                                :label="$t('Сделайте выбор')"
                                class="input"
                                @change="CLEAR_PAGES"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-flex>
                    </v-layout>

                    <div v-if="filtered.length==0" class="subheading">{{ $t("Нет вопросов") }}</div>
                    <v-layout v-else :class="{'mx-3': $vuetify.breakpoint.xs}">
                        <v-expansion-panel
                            v-model="value"
                            expand
                        >
                            <v-expansion-panel-content
                                v-for="(item_list, index) in paginated"
                                :key="index"
                                expand-icon=""
                                @input="toggle_panel($event, item_list)"
                            >
                                {{ value }}
                                <v-layout slot="header" align-center wrap
                                          justify-space-between
                                >
                                    <v-flex xs12 sm8 md9
                                            :class="{'mb-3': $vuetify.breakpoint.smAndDown}"
                                    >
                                        <v-layout row wrap>
                                            <div class="body-2 mr-2">
                                                {{ getDate(item_list.date_create) }}
                                            </div>
                                            <div class="grey-text body-2 mr-4">
                                                {{ getTime(item_list.date_create) }}
                                            </div>
                                            <div class="grey-text body-2 mr-4">
                                                ID: {{ item_list.id }}
                                            </div>
                                            <div class="green-text body-2">
                                                {{ $t(item_list.theme) }}
                                            </div>
                                            <v-flex xs12 class="overflow-hidden">{{ active_item === item_list.id ? $t(item_list.text) : item_list.title }}</v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <labelTopic :class="item_list.status == 'answered' ? 'section-label--green' : 'section-label--white-shadow'">{{ item_list.status == 'answered' ? $t('Ответ получен') : $t('Обрабатывается') }}</labelTopic>
                                    <roundButton :icon_name="value[index] ? 'minus' : 'plus'" :class="{'btn--icon-white': value[index]}" class="ml-4" />
                                </v-layout>
                                <v-card class="mb-4">
                                    <v-layout row wrap>
                                        <div class="grey-text body-2 mr-2">
                                            {{ $t("Ответ получен") }}:
                                        </div>
                                        <div class="body-2 mr-2">
                                            {{ getDate(item_list.date_answer) }}
                                        </div>
                                        <div class="grey-text body-2 mr-4">
                                            {{ getTime(item_list.date_answer) }}
                                        </div>
                                    </v-layout>
                                    <div>{{ item_list.answer }}</div>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-layout>
                    <v-layout my-5 align-center
                              wrap :class="{'mx-3': $vuetify.breakpoint.xs, 'justify-center': $vuetify.breakpoint.xs, 'justify-space-between': $vuetify.breakpoint.smAndUp}"
                    >
                        <v-flex md3 sm3 xs6
                                class="text-xs-center text-sm-left"
                                :class="{'mb-4': $vuetify.breakpoint.smAndDown}"
                        >
                            <buttonRed :class="{'mr-5': $vuetify.breakpoint.smAndUp}" @click.native="OPEN_CONTACT_MODAL()">{{ $t("Задать вопрос") }}</buttonRed>
                        </v-flex>
                        <v-flex v-if="filtered.length > 10" md5
                                sm7
                                xs12
                                :class="{'mb-4': $vuetify.breakpoint.smAndDown}"
                        >

                            <div class="text-xs-center">
                                <v-pagination
                                    v-model="page"
                                    :length="Math.ceil(filtered.length / selected_number)"
                                    :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                                    prev-icon="arrow_back_ios"
                                    next-icon="arrow_forward_ios"
                                />
                            </div>
                        </v-flex>
                        <v-flex v-if="filtered.length > 10" md4 sm6
                                :class="{'mb-2': $vuetify.breakpoint.smAndDown}"
                                class="pagin_cont"
                        >
                            <v-select
                                :items="$vuetify.breakpoint.mdAndUp ?
                                    [
                                        {
                                            text: $t('Показывать по 10'),
                                            value: 'Показывать по 10',
                                        },
                                        {
                                            text: $t('Показывать по 25'),
                                            value: 'Показывать по 25',
                                        },
                                        {
                                            text: $t('Показывать по 50'),
                                            value: 'Показывать по 50',
                                        },
                                        {
                                            text: $t('Показывать по 100'),
                                            value: 'Показывать по 100',
                                        },
                                    ]
                                    :
                                    [
                                        {
                                            text: $t('Показывать по 10'),
                                            value: 'Показывать по 10',
                                        },
                                        {
                                            text: $t('Показывать по 25'),
                                            value: 'Показывать по 25',
                                        },
                                        {
                                            text: $t('Показывать по 50'),
                                            value: 'Показывать по 50',
                                        },
                                ]"
                                solo
                                append-icon=""
                                :label="$t('Показывать по 10')"
                                class="input"
                                @change="show_number($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                </div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import labelTopic   from '@/components/ui/labels/label_topic';
import buttonRed   from '@/components/ui/buttons/button_red';
import roundButton   from '@/components/ui/buttons/buttons_icon/round_button';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonRed,
    roundButton,
    labelTopic,
  },
  data() {
    return {
      value : [],
      search: '',
    };
  },
  computed: {
    ...mapGetters('contact/breadcrumbs', [
      'breadcrumbs',
    ]),
    ...mapGetters('contact/requests', [
      'list',
      'request_modal',
      'themes',
      'selected_page',
      'selected_theme',
      'selected_number',
      'filtered_by_theme',
      'search_by_string',
      'paginated',
      'search_string',
      'active_item',
    ]),
    translatedThemes() {
      return this.themes.map((theme) => ({
        text : this.$t(theme),
        value: theme,
      }));
    },
    theme: {
      get() {
        return this.selected_theme;
      },
      set($event) {
        return this.SET_SELECTED_THEME($event);
      },
    },
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    questions_search: {
      get() {
        return this.search_string;
      },
      set($event) {
        return this.SEARCH_STRING($event.target.value);
      },
    },
    filtered() {
      return this.search_string ? this.search_by_string : this.filtered_by_theme;
    },
    ...mapGetters('common', ['learning_rules']),
  },
  async mounted() {
    await this.get_feedback_questions();
  },
  methods: {
    toggle_panel(is_open, item) {
      if (is_open) {
        this.SET_ACTIVE_ITEM(item.id);
      } else {
        this.SET_ACTIVE_ITEM(null);
      }
    },
    getDate(date) {
      if (date) {
        return date.split(' ')[0];
      }
      return new dayjs().format('DD.MM.YYYY');
    },
    getTime(date) {
      if (date) {
        return date.split(' ')[1].slice(0, 5);
      }
      return new dayjs().format('HH.mm');
    },
    ...mapMutations('contact/requests', [
      'CLOSE_MODAL',
      'OPEN_CONTACT_MODAL',
      'SET_SELECTED_THEME',
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SEARCH_STRING',
      'SET_ACTIVE_ITEM',
    ]),
    ...mapActions('contact/requests', [
      'show_number',
      'get_feedback_questions',
    ]),
  },
};
</script>

<style lang="less" scoped>
.section-title {
  margin-left: 0
}
</style>
